import addLog from "../utils/addLog";
import isDevMode from "./isDevMode";

const getSales = async (
  url: string,
  authToken: string,
  isToUseAuthZero: boolean
) => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  if (isDevMode() && !isToUseAuthZero) {
    headers = { ...headers, Authorization: `bearer ${process.env.TOKEN}` };
  }

  let res = null;
  let data = null;

  try {
    res = await fetch(url, {
      method: "GET",
      headers,
    });
    data = await res.json();
  } catch (e) {
    addLog({ message: e.message, error: e, severity: "error" });
    throw new Error(`${res.status} ${e.message}.`);
  }
  return data;
};

export default getSales;
